import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTransactionDetails, getMessageToShow, getUTCTime } from 'actions/index';
import { 
  Button,
  Grid, 
  Typography
} from '@mui/material';
import { styled } from "@mui/material/styles";
import moment from 'moment';
import { FaLeaf } from "react-icons/fa";
import TimeWindowTimer from '../../components/timeWindowTimer';
import { TrackingSpinner } from 'containers/common/tracking_spinner';

const WindowButton = styled(Button)(({ theme }) => ({
  display: "block",
  textTransform: "none",
  border: "2px solid",
  width: "100%",
  height: "50px",
  padding: "0px",
  boxShadow: "2px 2px 5px #ccc",
  '&.MuiButton-root': { 
    '&:hover': {
      border: "2px solid",
      borderColor: "#008000",
      backgroundColor: "#F4FFF6 !important",
      color: "#008000"
    },
    '&:focus': {
      borderColor: "#008000 !important"
    }  
  }
}));

// const ButtonIcon = styled(FaLeaf)(({theme}) => ({
//   color: "#008000",
//   // width: {xs: "8%", sm: "8%", md: "8%"}
// }));

export class TimeWindow extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      scheduleDate: "",
      preSelectedTWExists: false,
      windowSelected: false,
      windowId: "",
      greenLeafMatched: false,
      calendarDate: "",
      buttonActive: false,
      loadingComplete: false,
      loadSpinner: false,
      greenFlagAvailable: false,
      buttonClicked: false,
      displayNoTWMessageSameDate: JSON.parse(process.env.REACT_APP_DISPLAY_NO_TW_MESSAGE_SAME_DATE),
      noTWErrorMessageSameDate: process.env.REACT_APP_NO_TW_MESSAGE_SAME_DATE,
      displayNoTWMessageDiffDate: JSON.parse(process.env.REACT_APP_DISPLAY_NO_TW_MESSAGE_DIFF_DATE),
      noTWErrorMessageDiffDate: process.env.REACT_APP_NO_TW_MESSAGE_DIFF_DATE,
      displayCustomButton: true,
      displayFDLabel: JSON.parse(process.env.REACT_APP_DISPLAY_FD_LABEL),
      fullDayLabelCharLimit: JSON.parse(process.env.REACT_APP_FD_LABEL_CHR_LIMIT),
      twAllowed: true,
      activeStart: "",
      activeEnd: ""
    }
  }

  componentDidMount() {
    this.props.shareMethods(this.renderTimeWindows.bind(this));
    const {unselectedTW} = this.props.transactionDetails;
    const unselectedTWList = this.props.transactionDetails.unselectedTW;
    if (unselectedTWList && Array.isArray(unselectedTWList) && !this.props.timeWindows.length) {
      unselectedTW.map(item => {
        if (item.hjScheduleDate === this.props.changedDate && this.props.transactionDetails.hjStartTime !== item.hjStartTime && this.props.transactionDetails.hjEndTime !== item.hjEndTime) {
          this.setState({
            displayCustomButton: false,
          });
        }
      })
    }
    if(this.props.transactionDetails.startTime !== undefined && this.props.transactionDetails.startTime !== null
      && this.props.transactionDetails.startTime !== "" && this.props.transactionDetails.endTime !== undefined 
      && this.props.transactionDetails.endTime !== null && this.props.transactionDetails.endTime !== "") {
        var startTime = "";
        var endTime = "";
        var selectedWindow = false;
        var routeID = "";
        var stopNumber = "";
        var score = "";
        var scheduleKey = "";
        var greenLeafAvailable = false;
        var greenLeafSelected = false;
          if(this.props.changedDate !== null && this.props.transactionDetails.scheduleDate === this.props.changedDate) {
            const preSelectedTW = moment.utc(this.props.transactionDetails.startTime, ["HH:mm"]).format('hh:mma');
            const preSelectedTWEnd = moment.utc(this.props.transactionDetails.endTime, ["HH:mm"]).format('hh:mma');
            if(Array.isArray(this.props.timeWindows) && this.props.timeWindows.length) {
              const greenLeafFound = this.props.timeWindows[0].timeWindowsList.find(leaf => leaf.greenFlag) ? true : false;
              const existingWindow = this.props.timeWindows[0].timeWindowsList.find(window => window.startTime === this.props.transactionDetails.startTime && window.endTime === this.props.transactionDetails.endTime);
              const greenLeafPreselected = this.props.timeWindows[0].timeWindowsList.find(window => window.startTime === this.props.transactionDetails.startTime && window.endTime === this.props.transactionDetails.endTime && window.greenFlag) ? true : false;
              routeID = existingWindow ? existingWindow.routeID : "";
              stopNumber = existingWindow ? existingWindow.stopNumber : "";
              score = existingWindow ? existingWindow.score : "";
              scheduleKey = this.props.timeWindows[0]?.scheduleKey ? this.props.timeWindows[0]?.scheduleKey : "";
              greenLeafAvailable = greenLeafFound;
              greenLeafSelected = greenLeafPreselected;
            } else if(!this.props.timeWindows.length || !this.props.timeWindows.length < 1) {
              if(this.props.transactionDetails.hjStartTime === this.props.transactionDetails.allDayTWStart && this.props.transactionDetails.hjEndTime === this.props.transactionDetails.allDayTWEnd) {
                this.setState({ displayCustomButton: false });
              } else {
                this.setState({ displayCustomButton: true });
              }
            }
            this.setState({ scheduleDate: this.props.transactionDetails.scheduleDate, preSelectedTWExists: true, windowId: preSelectedTW + "-" + preSelectedTWEnd + "selected", windowSelected: true });
            this.setState({ activeStart: this.props.transactionDetails.startTime, activeEnd: this.props.transactionDetails.endTime});
            if(moment(this.props.transactionDetails.scheduleDate).isSameOrAfter(Date())) {
              startTime = this.props.transactionDetails.startTime;
              endTime = this.props.transactionDetails.endTime;
              selectedWindow = true;
            } 
            // else {
            //   startTime = "";
            //   endTime = "";
            //   selectedWindow = false;
            // }
          } else {
            if(this.props.changedDate === this.props.transactionDetails.hjScheduleDate) {
              if(this.props.transactionDetails.hjStartTime !== undefined && this.props.transactionDetails.hjStartTime !== null
                && this.props.transactionDetails.hjStartTime !== "" && this.props.transactionDetails.hjEndTime !== undefined
              && this.props.transactionDetails.hjEndTime !== null && this.props.transactionDetails.hjEndTime !== "") {
                    const preSelectedTW = moment.utc(this.props.transactionDetails.hjStartTime, ["HH:mm"]).format('hh:mma');
                    const preSelectedTWEnd = moment.utc(this.props.transactionDetails.hjEndTime, ["HH:mm"]).format('hh:mma');
                    if(Array.isArray(this.props.timeWindows) && this.props.timeWindows.length) {
                      const greenLeafFound = this.props.timeWindows[0].timeWindowsList.find(leaf => leaf.greenFlag) ? true : false;
                      const existingWindow = this.props.timeWindows[0].timeWindowsList.find(window => window.startTime === this.props.transactionDetails.hjStartTime && window.endTime === this.props.transactionDetails.endTime);
                      const greenLeafPreselected = this.props.timeWindows[0].timeWindowsList.find(window => window.startTime === this.props.transactionDetails.hjStartTime && window.endTime === this.props.transactionDetails.endTime && window.greenFlag) ? true : false;
                      routeID = existingWindow ? existingWindow.routeID : "";
                      stopNumber = existingWindow ? existingWindow.stopNumber : "";
                      score = existingWindow ? existingWindow.score : "";
                      scheduleKey = this.props.timeWindows[0]?.scheduleKey ? this.props.timeWindows[0]?.scheduleKey : "";
                      greenLeafAvailable = greenLeafFound;
                      greenLeafSelected = greenLeafPreselected;
                    }
                    
                    this.setState({ preSelectedTWExists: true, windowId: preSelectedTW + "-" + preSelectedTWEnd +"selected" });
                    if(moment(this.props.transactionDetails.scheduleDate).isSameOrAfter(Date())) {
                      startTime = this.props.transactionDetails.hjStartTime;
                      endTime = this.props.transactionDetails.hjEndTime
                      selectedWindow = true;
                    }
                } else {
                  this.setState({ displayCustomButton: false });
                }
            } else {
              if(!this.props.timeWindows.length || !this.props.timeWindows.length < 1) {
                this.setState({
                  displayCustomButton: false,
                });
              }
            }
          }

       
        let windowData = {};
        windowData = {
          startTime: startTime,
          endTime: endTime,
          windowSelected: selectedWindow,
          greenFlagAvailable: greenLeafAvailable,
          greenFlagSelected: greenLeafSelected,
          routeID: routeID,
          stopNumber: stopNumber,
          score: score,
          scheduleKey: scheduleKey
        };

        this.props.timeWindowData(windowData);
        

      } else {        
        var selection = false;
        if(this.props.timeWindows !== null && this.props.timeWindows.length) {
          selection = false;
        } else {
          selection = true;
        }
        var hjStartTime = "";
        var hjEndTime = "";
         if(this.props.changedDate !== null 
          && this.props.transactionDetails.hjScheduleDate === this.props.changedDate 
          && this.props.transactionDetails.hjStartTime && this.props.transactionDetails.hjEndTime) {
            hjStartTime = this.props.transactionDetails.hjStartTime;
            hjEndTime = this.props.transactionDetails.hjEndTime;
         } else {
          this.setState({ displayCustomButton: false });
         }
        
        let windowData = {};
        windowData = {
          startTime: hjStartTime,
          endTime: hjEndTime,
          windowSelected: selection,
          greenFlagAvailable: false,
          greenFlagSelected: false,
          routeID: "",
          stopNumber: "",
          score: "",
          scheduleKey: ""
        };
        this.props.timeWindowData(windowData);
      }
  }

  componentWillReceiveProps(nextProps) {
    if(Array.isArray(nextProps.timeWindows) && nextProps.timeWindows.length) {
      this.setState({ scheduleDate: nextProps.timeWindows[0].deliveryDate, loadingComplete: nextProps.loadingComplete });
      if(nextProps.changedDate !== undefined && nextProps.changedDate !== null && nextProps.changedDate !== "") {
        var nextTimeWindows = this.reloadTWComponent(nextProps);
        this.setState({ calendarDate: nextProps.changedDate, timeWindows: nextTimeWindows });
        var preSelectedTW = ""; 
        if(!nextProps.updateActiveTW) {
          if(nextProps.changedDate === this.props.transactionDetails.scheduleDate) {
            preSelectedTW = moment.utc(this.props.transactionDetails.startTime, ["HH:mm"]).format('hh:mma');
            const preSelectedTWEnd = moment.utc(this.props.transactionDetails.endTime, ["HH:mm"]).format('hh:mma');
            this.setState({ windowSelected: preSelectedTW + "-" + preSelectedTWEnd + "selected", buttonActive: true });
          } else if(nextProps.changedDate === this.props.transactionDetails.hjScheduleDate) {
            preSelectedTW = moment.utc(this.props.transactionDetails.hjStartTime, ["HH:mm"]).format('hh:mma');
            const preSelectedTWEnd = moment.utc(this.props.transactionDetails.hjEndTime, ["HH:mm"]).format('hh:mma');
            this.setState({ windowSelected: preSelectedTW + "-" + preSelectedTWEnd + "selected", buttonActive: true });
          }
          else {
            if(!this.state.buttonClicked) {
              this.setState({ windowSelected: preSelectedTW, buttonActive: false });
            }
          }
        } else {
          var twPresent = nextProps.timeWindows[0].timeWindowsList.find(window => window.startTime === nextProps.transactionDetails.startTime && window.endTime === nextProps.transactionDetails.endTime) ? true : false;
          if(twPresent) {
            preSelectedTW = moment.utc(this.props.transactionDetails.startTime, ["HH:mm"]).format('hh:mma');
            const preSelectedTWEnd = moment.utc(this.props.transactionDetails.endTime, ["HH:mm"]).format('hh:mma');
            this.setState({ windowId: preSelectedTW + "-" + preSelectedTWEnd + "selected", buttonActive: true });
          } else {
            if(this.props.updateActiveTW !== nextProps.updateActiveTW) {
              preSelectedTW = moment.utc(this.props.transactionDetails.hjStartTime, ["HH:mm"]).format('hh:mma');
              const preSelectedTWEnd = moment.utc(this.props.transactionDetails.hjEndTime, ["HH:mm"]).format('hh:mma');
              this.setState({ windowId: preSelectedTW + "-" + preSelectedTWEnd + "selected", buttonActive: true });
              const preScheduleWindow = nextProps.timeWindows[0].timeWindowsList.find(window => (window.startTime === this.props.transactionDetails.hjStartTime && window.endTime === this.props.transactionDetails.hjEndTime));
              let windowData = {};
              windowData = {
                startTime: this.props.transactionDetails.hjStartTime,
                endTime: this.props.transactionDetails.hjEndTime,
                windowSelected: true,
                greenFlagAvailable: nextProps.timeWindows[0].timeWindowsList.find(leaf => leaf.greenFlag) ? true : false,
                greenFlagSelected: nextProps.timeWindows[0].timeWindowsList.find(window => window.startTime === this.props.transactionDetails.hjStartTime && window.endTime === this.props.transactionDetails.hjEndTime && window.greenFlag) ? true : false,
                routeID: preScheduleWindow ? preScheduleWindow.routeID : "",
                stopNumber: preScheduleWindow ? preScheduleWindow.stopNumber : "",
                score: preScheduleWindow ? preScheduleWindow.score : "",
                scheduleKey: nextProps.timeWindows[0]?.scheduleKey ? this.props.timeWindows[0]?.scheduleKey : ""
              };
              this.props.timeWindowData(windowData);
            }
          }
        }
      }
    } else {
      if(nextProps.changedDate === nextProps.transactionDetails.hjScheduleDate && nextProps.transactionDetails.hjStartTime && nextProps.transactionDetails.hjEndTime) {
        if(this.props.updateActiveTW !== nextProps.updateActiveTW) {
          let windowData = {};
          windowData = {
            startTime: this.props.transactionDetails.hjStartTime,
            endTime: this.props.transactionDetails.hjEndTime,
            windowSelected: true,
            greenFlagAvailable: false,
            greenFlagSelected: false,
            routeID: "",
            stopNumber: "",
            score: "",
            scheduleKey: ""
          };
          this.props.timeWindowData(windowData);
        }
      } else {
        this.setState({ displayCustomButton: false });
        if(this.props.updateActiveTW !== nextProps.updateActiveTW) {
          let windowData = {};
          windowData = {
            startTime: "",
            endTime: "",
            windowSelected: true,
            greenFlagAvailable: false,
            greenFlagSelected: false,
            routeID: "",
            stopNumber: "",
            score: "",
            scheduleKey: ""
          };
          this.props.timeWindowData(windowData);
        }
      }
    }
}

reloadTWComponent = (nextProps) => {
  var newWindows = {};
  if(nextProps.timeWindowAllowed === true) {
    newWindows = nextProps.timeWindows
  } else {    
    var windowList = [];
    windowList = nextProps.timeWindows[0].timeWindowsList.filter(window => !(window.startTime === this.state.activeStart && window.endTime === this.state.activeEnd));
    nextProps.timeWindows[0].timeWindowsList = windowList;
    newWindows = nextProps.timeWindows;
    this.props.twAllowedReset(true);
  }
  return newWindows;
}

noDCEWindowsResponse = () => {
  var noTWSameDate = this.state.noTWErrorMessageSameDate.replace('%dt', moment.utc(this.props.transactionDetails.hjScheduleDate).format('LLL').substring(0, moment.utc(this.props.transactionDetails.hjScheduleDate).format('LLL').length - 8));
  var noTWDiffDate = this.state.noTWErrorMessageDiffDate.replace('%dt', moment.utc(this.props.changedDate).format('LLL').substring(0, moment.utc(this.props.changedDate).format('LLL').length - 8));
    return(
      <div>
        <p><span style={{ fontWeight: "bold" }}>Time Window</span></p>
        <p>
          {this.state.displayCustomButton === true && (this.props.transactionDetails.scheduleDate && this.props.transactionDetails.hjScheduleDate === this.props.changedDate 
          && (this.props.transactionDetails.hjStartTime !== this.props.transactionDetails.allDayTWStart || this.props.transactionDetails.hjEndTime !== this.props.transactionDetails.allDayTWEnd)) &&
            <div>
            <Grid container rowSpacing={2} columnSpacing={1} aria-label="Time Windows">              
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <WindowButton
              variant="outlined"
              sx={{borderColor: "#008000 !important", color: "#008000", backgroundColor: "#F4FFF6"}}>
                <Typography 
                id={this.props.transactionDetails.hjStartTime + "*" + this.props.transactionDetails.hjEndTime} 
                sx={{ fontSize: {xs: "15px", sm: "15px", md: "14px", lg: "15px"} }}
                >
                  {(moment.utc(this.props.transactionDetails.hjStartTime, ["HH:mm"]).format('h:mma'))} - {(moment.utc(this.props.transactionDetails.hjEndTime, ["HH:mm"]).format('h:mma'))}
                </Typography>
              </WindowButton>
            </Grid>
          </Grid></div>}
          {this.state.displayCustomButton === true && (this.props.transactionDetails.scheduleDate && this.props.transactionDetails.hjScheduleDate === this.props.changedDate 
          && this.props.transactionDetails.hjStartTime === this.props.transactionDetails.allDayTWStart && this.props.transactionDetails.hjEndTime === this.props.transactionDetails.allDayTWEnd) &&
            <div class="dceNoWindows">
              <p>
                <span>{noTWSameDate}</span>
              </p>
            </div>
          }
          {this.state.displayCustomButton === false && (this.state.displayNoTWMessageSameDate && this.props.transactionDetails.hjScheduleDate === this.props.changedDate) &&
            <div class="dceNoWindows">
              <p>
                <span>{noTWSameDate}</span>
              </p>
            </div>
          }
          {this.state.displayCustomButton === false && (this.state.displayNoTWMessageDiffDate && this.props.transactionDetails.hjScheduleDate !== this.props.changedDate) &&
            <div class="dceNoWindows">
              <p>
                <span>{noTWDiffDate}</span>
              </p>
            </div>
          }
        </p>
      </div>
    )
}

  renderTimeWindows = () => {
    const validDate = this.props.requestDate === this.props.changedDate ? true : false;
    if(this.state.timeWindows !== null && this.state.timeWindows !== undefined) {      
      let timeWindows = "";
      timeWindows = this.state.timeWindows;
      const labelCharCount = timeWindows ? timeWindows[0]?.alldaytimeWindowLabel.length : 0;
      if(Array.isArray(timeWindows) && timeWindows.length && validDate) {
        if(timeWindows[0].timeWindowsList !== null && timeWindows[0].timeWindowsList !== undefined &&
          Array.isArray(timeWindows[0].timeWindowsList) && timeWindows[0].timeWindowsList.length) {
          const scheduleKey = timeWindows[0]?.scheduleKey ? timeWindows[0]?.scheduleKey : "";  
          const dateMatched = timeWindows.find(day => (moment.utc(day.deliveryDate).format('YYYY-MM-DD')) === this.state.scheduleDate);
          const greenLeafFound = dateMatched.timeWindowsList.find(leaf => leaf.greenFlag) ? true : false;
          const duplicateWindow = dateMatched.timeWindowsList.find(window => window.startTime === this.props.transactionDetails.hjStartTime && window.endTime === this.props.transactionDetails.hjEndTime) ? true : false;
          if(this.state.preSelectedTWExists && !duplicateWindow 
            && this.props.transactionDetails.hjStartTime !== null 
            && this.props.transactionDetails.hjStartTime !== "" 
            && this.props.transactionDetails.hjEndTime !== null
            && this.props.transactionDetails.hjEndTime !== ""
            && this.state.calendarDate === this.props.transactionDetails.hjScheduleDate
            ) {
            let customWindow = {
              startTime: this.props.transactionDetails.hjStartTime,
              endTime: this.props.transactionDetails.hjEndTime,
              greenFlag: false,
              stopNumber: "",
              routeID: "",
              score: "",
              scheduleKey: ""
            }
            dateMatched.timeWindowsList.push(customWindow);          
          }
          dateMatched.timeWindowsList.sort((a,b) => (a.endTime > b.endTime) ? 1 : ((b.endTime > a.endTime) ? -1 : 0));

          if(Array.isArray(dateMatched.timeWindowsList)) {
            return(
              <div>
                {this.state.loadingComplete && <div>
                  <p><span style={{ fontWeight: "bold" }}>Time Window</span></p>
                  <p>                  
                    <Grid container rowSpacing={2} columnSpacing={1} aria-label="Time Windows">
                      {dateMatched.timeWindowsList.map((windowSlot, index) => (
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <WindowButton
                          disableRipple
                          variant="outlined"                 
                          key={index}
                          onClick={e => this.handleOnClick(windowSlot, greenLeafFound, scheduleKey)}
                          id={windowSlot.startTime + "*" + windowSlot.endTime + "*" + windowSlot.greenFlag + "*" + windowSlot.routeID + "*" + windowSlot.stopNumber + "*" + greenLeafFound }
                          focusVisibleClassName='activeClass'
                          sx={this.state.buttonActive && (this.state.windowId === moment.utc(windowSlot.startTime, ["HH:mm"]).format('hh:mma') + "-" + moment.utc(windowSlot.endTime, ["HH:mm"]).format('hh:mma') + "selected") ? {borderColor: "#008000 !important", color: "#008000", backgroundColor: "#F4FFF6"} : ""}
                          >
                            {windowSlot.greenFlag ? 
                            <Typography
                            sx={{ pointerEvents: "none", padding: "0px 5px 0px 0px", marginBottom: {xs: "-11px", sm: "-10px", md: "-10px", lg: "-8px"}, marginTop: {xs: "-15px", sm: "-15px", md: "-15px", lg: "-12px"}, textAlign: "right" }}
                            >
                              {/* {<ButtonIcon sx={{ marginBottom: {xs: "8px",sm: "4px", md: "8px", lg: "6px"}, width:{xs: "10%", sm: "10%", md:"9%", lg: "8%"}}} />} */}
                              <img src={require('../../images/CostcoIcon_clear.png')} />
                            </Typography> : ""}
                            <Typography 
                            sx={{ pointerEvents: "none", fontSize: {xs: "15px", sm: "14px", md: "14px", lg: "1.03em"} }}
                            >
                              {this.state.displayFDLabel === true && windowSlot.startTime === this.props.transactionDetails.allDayTWStart && 
                              windowSlot.endTime === this.props.transactionDetails.allDayTWEnd &&
                              labelCharCount <= this.state.fullDayLabelCharLimit && (<div style={{textAlign: "center", width: "100%"}}><span>{timeWindows[0]?.alldaytimeWindowLabel}</span></div>)}
                              {moment.utc(windowSlot.startTime, ["HH:mm"]).format('h:mma')} - {moment.utc(windowSlot.endTime, ["HH:mm"]).format('h:mma')}
                            </Typography>
                          </WindowButton>
                        </Grid>
                      ))}
                    </Grid>
                    <TimeWindowTimer />
                    {greenLeafFound && <div className="col" style={{ marginTop: "8px", fontSize: "14px"}}>
                      <span><img src={require('../../images/CostcoIcon_clear.png')} />  Most Efficient</span>
                    </div>}
                  </p>  
                </div>}
              </div>
            )    
          }
        } else {
          return (
            <div>
              {this.noDCEWindowsResponse()}
            </div>
            )
        }
      }
    } else {
      return(
      <div>
        {validDate && this.noDCEWindowsResponse()}
      </div>
      )
    }
  }
  

  handleOnClick = (windowProps, greenLeafAvailable, scheduleKey) => {
    // const timeWindow = e.target.id ? e.target.id : e.target.offsetParent.id;
    // const timeSpots = timeWindow.split('*');
    const startTime = (moment.utc(windowProps.startTime, ["HH:mm"]).format('hh:mma'));
    const endTime = (moment.utc(windowProps.endTime, ["HH:mm"]).format('hh:mma'));
    this.state.buttonClicked = true;
    this.setState({ 
      buttonActive: true, 
      windowSelected: windowProps.startTime !== "" ? true : false, windowId: startTime + "-" + endTime + "selected",
      activeStart: windowProps.startTime,
      activeEnd: windowProps.endTime
    });

    let windowData = {
      startTime: windowProps.startTime,
      endTime: windowProps.endTime,
      windowSelected: true,
      greenFlagAvailable: greenLeafAvailable !== null ? greenLeafAvailable : "",
      greenFlagSelected: windowProps.greenFlag !== null ? windowProps.greenFlag : "",
      routeID: windowProps.routeID,
      stopNumber: windowProps.stopNumber ? windowProps.stopNumber : "",
      score: windowProps.score ? windowProps.score : "",
      scheduleKey: scheduleKey ? scheduleKey : ""
    };
    this.props.timeWindowData(windowData);
 }

    render() {
        return (
            <div>
                {this.renderTimeWindows()}
            </div>
        )
    }
};

function mapStateToProps(state) {
  return {
    transactionDetails: state.transactionDetails,
    timeWindows: state.timeWindows
  };
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ getTransactionDetails, getMessageToShow, getUTCTime }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps) (TimeWindow);